import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=4d06a4de&"
import script from "./Chart.vue?vue&type=script&lang=js&"
export * from "./Chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bsjung/work/xtc/trading-chart-js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d06a4de')) {
      api.createRecord('4d06a4de', component.options)
    } else {
      api.reload('4d06a4de', component.options)
    }
    module.hot.accept("./Chart.vue?vue&type=template&id=4d06a4de&", function () {
      api.rerender('4d06a4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chart.vue"
export default component.exports